import RowModel from '@/components/layout/row/RowModel';
import { SdkColumnModel } from './column';

export class SdkRowModel {
  #model: RowModel;

  constructor(model: RowModel) {
    this.#model = model;
  }

  public get Columns() {
    return this.#model.state.columns.map((column) => new SdkColumnModel(column));
  }

  public get id(): number {
    return Number(this.#model.state.id);
  }

  public get label(): string | undefined {
    return this.#model.state.label;
  }
}
